import { COACH_ROLE, TEAM_ROLE, TEAM_ROLE_OPTIONS, TeamAthlete } from '@type/db-types';
import {
    CircularProgress,
    MenuItem,
    Select,
    SelectChangeEvent,
    Tooltip,
    Typography,
} from '@mui/material';
import { updateTeamRole } from '@modules/supabase/teams';
import useUser from '@hooks/useUser';
import { useState } from 'react';

interface Props {
    refresh?: () => void;
    user: Pick<TeamAthlete, 'id' | 'membershipId' | 'role'>;
}

export default function TeamRoleSelector({ refresh, user }: Props) {
    const currentUser = useUser();
    const { membershipId, role } = user;
    const [loading, setLoading] = useState(false);

    const handleChange = async ({ target: { value: role } }: SelectChangeEvent) => {
        if (!membershipId) return;

        setLoading(true);
        await updateTeamRole(role as TEAM_ROLE, membershipId);

        // invalidate local user data & refetch
        refresh?.();
        setLoading(false);
    };

    if (loading) return <CircularProgress />;

    if (!user) return null;

    // Prevent admins from demoting themselves and breaking their setup
    if (currentUser.user?.id === user.id && user.role && COACH_ROLE.includes(user.role))
        // <div>
        return (
            <Tooltip title={'You cannot change your own permissions'}>
                <Typography variant="body2">
                    {TEAM_ROLE_OPTIONS.find((r) => r.value === role)?.label || role} (You)
                </Typography>
            </Tooltip>
        );

    return (
        <Select size="small" onChange={handleChange} value={role} sx={{ paddingBottom: '0rem' }}>
            {TEAM_ROLE_OPTIONS.map(({ label, value }) => (
                <MenuItem key={value} value={value} sx={{ paddingBottom: '0rem' }}>
                    <Typography variant="body2">{label}</Typography>
                </MenuItem>
            ))}
        </Select>
    );
}
